import { ListStateWithLoadingState } from '../_commons/state.common';
import { JobOfferView, QuestionnaireElement } from './jobOffers.dto';

export const initialState: JobOffersState = {
    list: [],
    items: {},
    totalCount: 0,
    isLoading: false,
    error: null
};

export interface JobOffersState extends ListStateWithLoadingState<string, JobOffer> {}

export type JobOffer = Omit<JobOfferView, 'questionnaireStructure'> & {
    questionnaireStructure: JobOfferQuestionnaire;
};

export interface JobOfferQuestionnaire {
    pages: JobOfferQuestionnairePage[];
}

export interface JobOfferQuestionnairePage {
    pageNumber: number;
    elements: QuestionnaireElement[];
}
